declare global {
  interface Window {
    _hsq?: any[]
  }
}

export const identifyHubSpotUser = (user: {
  email: string
  firstName?: string
  lastName?: string
}) => {
  if (typeof window === "undefined") return
  if (!window._hsq) return

  window._hsq.push([
    "identify",
    {
      email: user.email,
      firstname: user.firstName,
      lastname: user.lastName,
    },
  ])
}

export const resetHubSpotUser = () => {
  if (typeof window === "undefined") return
  if (!window._hsq) return

  window._hsq.push(["reset"])
}
